<div class="app-info-box border-lightblack border px-2 py-1 px-lg-4 py-lg-3">
  <span class="text color-lightblack">
    {{ text }}
  </span>
</div>
